import MarketSnapshotsBaseController from 'lumen/controllers/market/snapshots/base';
import type MarketSnapshotsBudgetRoute from 'lumen/routes/market/snapshots/budget';
import { SNAPSHOT_VIEW_CONFIG } from 'lumen/utils/constants/market-snapshots-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSnapshotsBudgetController extends MarketSnapshotsBaseController {
  declare model: ModelFrom<MarketSnapshotsBudgetRoute>;

  readonly config = SNAPSHOT_VIEW_CONFIG.budget;
}
